export default __webpack_public_path__ + "static/bw-d86b28938d31ba136951b4e087a08236.svg";